// src/components/MissionVision.js
import React from 'react';

const MissionVision = ({ mission, vision }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
      <div className="rounded-xl shadow-lg p-8 transform transition-all duration-300 hover:scale-105 hover:shadow-xl border" style={{ backgroundColor: '#211F1F', borderColor: '#333' }}>
        <div className="text-5xl mb-4">🎯</div>
        <h3 className="text-2xl md:text-3xl font-bold mb-3" style={{ color: '#E8B00C' }}>Nuestra Misión</h3>
        <p className="text-gray-300 leading-relaxed text-base md:text-lg text-justify">{mission}</p>
      </div>
      
      <div className="rounded-xl shadow-lg p-8 transform transition-all duration-300 hover:scale-105 hover:shadow-xl border" style={{ backgroundColor: '#211F1F', borderColor: '#333' }}>
        <div className="text-5xl mb-4">👁️</div>
        <h3 className="text-2xl md:text-3xl font-bold mb-3" style={{ color: '#E8B00C' }}>Nuestra Visión</h3>
        <p className="text-gray-300 leading-relaxed text-base md:text-lg text-justify">{vision}</p>
      </div>
    </div>
  );
};

export default MissionVision;